module.exports = __webpack_public_path__ + "static/media/service-girl-standing.7fda3634.jpg";